import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "./components/layout/Nav";
import { Footer } from "./components/layout/Footer";
import Home from "./pages/Home";
import { Privacy, Terms, Cookies } from "./pages/Legal";
import DeleteAccount from "./pages/DeleteAccount";
import Support from "./pages/Support";
import Invite from "./pages/Invite";
import NotFound from "./pages/NotFound";

// Scroll to top on route change; honour in-page hash links.
function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <div className="min-h-screen bg-cream">
      <ScrollManager />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/support" element={<Support />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/invite/:token" element={<Invite />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
